import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function InvoiceIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 23.3072V10.0678C5 6.50031 5 4.71656 6.09835 3.60829C7.1967 2.5 8.96446 2.5 12.5 2.5H17.5C21.0355 2.5 22.8032 2.5 23.9016 3.60829C25 4.71656 25 6.50031 25 10.0678V23.3072C25 25.1969 25 26.1416 24.4225 26.5135C23.4789 27.1214 22.0201 25.8468 21.2864 25.3841C20.6801 25.0018 20.3771 24.8106 20.0406 24.7996C19.6771 24.7876 19.3686 24.971 18.7136 25.3841L16.325 26.8905C15.6806 27.2967 15.3585 27.5 15 27.5C14.6415 27.5 14.3194 27.2967 13.675 26.8905L11.2864 25.3841C10.6802 25.0018 10.3771 24.8106 10.0407 24.7996C9.67715 24.7876 9.36866 24.971 8.71359 25.3841C7.97994 25.8468 6.52109 27.1214 5.57744 26.5135C5 26.1416 5 25.1969 5 23.3072Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 7.5H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.5H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.125 12.3438C17.0895 12.3438 16.25 13.0782 16.25 13.9844C16.25 14.8905 17.0895 15.625 18.125 15.625C19.1605 15.625 20 16.3595 20 17.2656C20 18.1718 19.1605 18.9062 18.125 18.9062M18.125 12.3438C18.9414 12.3438 19.6359 12.8002 19.8933 13.4375M18.125 12.3438V11.25M18.125 18.9062C17.3086 18.9062 16.6141 18.4498 16.3567 17.8125M18.125 18.9062V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
